// extracted by mini-css-extract-plugin
export default {"myTabs":"tabs_myTabs__Pte2D","badge":"tabs_badge__4SPyP","badge-yellow":"tabs_badge-yellow__t1l02","badge-green":"tabs_badge-green__usylZ","badge-red":"tabs_badge-red__57hYe"};